import { USER_LOAD_DATA_URL } from 'moduleUser/constants';

var userLoadData = function userLoadData() {
  return function (_, __, _ref) {
    var networkService = _ref.networkService;
    return networkService.get(USER_LOAD_DATA_URL, null).then(function (response) {
      return response;
    });
  };
};

export { userLoadData };